<template>
    <div v-if="!isMobile" v-loading="loading" class="Articles">
        <div class="back" @click="back">{{ langPage['v4-articles']['TXT_retourauxcommandes'] }}</div>
        <p class="SubTitle">{{ 'Commande #' + command_group.id_commande_groupe }}</p>
        <div class="table">
            <div v-for="(item,i) in tablelist" :key="item.key">
                <p>{{ item.title }}</p>
                <span>{{ getTableValue(item) }}</span>
            </div>
        </div>

        <div class="tab">
            <p :class="i==active?'active':''" v-for="(item,i) in tabList" :key="item" @click="chooseTab(i)">
                {{ item }}
                <span v-if="i==0">{{ `(${commandes.length})` }}</span>
                <span v-if="i==1">{{ `(${stockout_products.length})` }}</span>
            </p>
        </div>

        <div v-if="active===0">
            <tableCard :data-all="dataAll"></tableCard>
        </div>
        <div v-if="active===1" class="cont">
            <div class="flex" v-for="(prod,i) in stockout_products" :key="prod.id_produit">
                <el-image
                    class="img"
                    fit="cover"
                    :lazy='true'
                    :src="`${$common.imgHost}Images/Boutiques/${prod.id_vendeur}/Produits/accueil/${prod.id_produit}-c.jpg`"
                ></el-image>
                <div class="left">
                    <div class="item color">
                        <p>#{{ prod.reference.length > 7 ? prod.reference.substr(0, 7) + '...' : prod.reference }}</p>
                        <div class="cercle">
                            <span
                                :style="{backgroundColor:typeof prod.couleur_value==='string'?prod.couleur_value:prod.couleur_value[0]}"></span>
                            <div>{{
                                    typeof
                                        prod.couleur_value === 'string' ? prod.couleur_name : prod.couleur_name[0]
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="size">
                        <el-scrollbar>
                            <div class="sku">
                                <div v-for="(size,sizeIndex) in prod.sizeList"
                                     class="item">
                                    <p>{{ size.size }}</p>
                                    <span v-if="prod.vendu_par!='tailles'">{{ size.num * prod.copeText }}</span>
                                    <span v-else type="text" v-text="size.num"/>
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div class="price">
                        <div class="total">
                            <div class="item" v-if="prod.vendu_par!='tailles'">
                                <p>{{ langPage['bov-catalogue-fiche']['TXT_paquet'] }}</p>
                                <span>{{ prod.pack_qte }}</span>
                                <!-- <span>{{prod.lignes.quantite_pack}}</span> -->
                            </div>
                            <div class="item">
                                <p>{{ langPage['v4-panier']['TXT_totalqte'] }}</p>
                                <span v-if="prod.vendu_par!=='tailles'">{{ prod.packTotal * prod.copeText }}</span>
                                <span v-else>{{ prod.qteTotal }}</span>
                                <!-- <span>{{prod.lignes.quantite_pack}}</span> -->
                            </div>
                            <div class="item">
                                <p>{{ langPage['v4-panier']['TXT_puht'] }}</p>
                                <span :class="{'item-other':prod.prixReduit}"
                                      v-if="!prod.prixReduit">{{ prod.prix }} €</span>
                                <span v-if="prod.prixReduit">{{ prod.prixReduit }} €</span>
                            </div>
                            <div class="item">
                                <p>{{ langPage['compte-commandes-virement-details']['TXT_totalht'] }}</p>
                                <span v-if="prod.vendu_par!=='tailles'">
                                        {{
                                        (prod.prixReduit ? prod.prixReduit * (prod.packTotal * prod.copeText) : prod.prix * (prod.packTotal * prod.copeText)).toFixed(2)
                                    }}€</span>
                                <span
                                    v-else>{{
                                        (prod.prixReduit ? prod.prixReduit * prod.qteTotal : prod.prix * prod.qteTotal)
                                    }}€</span>
                            </div>
                        </div>
                    </div>
                    <section class="line"></section>
                </div>
            </div>
        </div>
        <div v-if="active===2">
            <div class="adresses">
                <div class="left mr">
                    <p>{{ langPage['compte-popup-adresse']['TXT_adresselivraison'] }}</p>
                    <addCarte width="2.6" :msg="adrLIVRAISON" :carteTitle="carteTitle"></addCarte>
                </div>
                <div class="left">
                    <p>{{ langPage['compte-popup-adresse']['TXT_adressefacturation'] }}</p>
                    <addCarte width="2.6" :msg="adrFACTURATION" :carteTitle="carteTitle"></addCarte>
                </div>
            </div>
        </div>
        <div v-if="active===3">
            <div class="paiement">
                <p>{{ langPage['bov-commande-detail']['TXT_modepaiement'] }}: {{ command_group.payment_name }}</p>
            </div>
        </div>
    </div>
    <div v-else v-loading="loading" class="mArticles">
        <div class="back" @click="back">{{ langPage['v4-articles']['TXT_retourauxcommandes'] }}</div>
        <p class="SubTitle">{{ 'Commande' }}</p>
        <p class="SubTitle">{{ '#' + command_group.id_commande_groupe }}</p>
        <div class="table">
            <div v-for="(item,i) in tablelist" :key="item.key">
                <p>{{ item.title }}</p>
                <span>{{ getTableValue(item) }}</span>
            </div>
        </div>

        <div class="tab">
            <p :class="i==active?'active':''" v-for="(item,i) in tabList" :key="item" @click="chooseTab(i)">
                {{ item }}
                <span v-if="i==0">{{ `(${commandes.length})` }}</span>
                <span v-if="i==1">{{ `(${stockout_products.length})` }}</span>
            </p>
        </div>

        <div v-if="active===0">
            <tableCard :data-all="dataAll"></tableCard>
        </div>
        <div v-if="active===1" class="cont">
            <div class="cont">
                <template
                    v-if="stockout_products && stockout_products.length>0">
                    <div class="container" v-for="(prod,i) in stockout_products" :key="i">
                        <div class="productImgBox">
                            <el-image
                                :lazy='true'
                                class="img"
                                fit="cover"
                                @click="$router.push(`/ProductDetail?id=${prod.id_produit}&vendu_par=${prod.vendu_par}&vid=${prod.id_vendeur}&categorie_id=${prod.id_categorie}`)"
                                :src="prod.produit_url"></el-image>
                            <div class="desc">
                                <p>{{ prod.reference }}</p>
                                <div class="cercle">
                                    <span
                                        :style="{backgroundColor:typeof prod.couleur_value==='string'?prod.couleur_value:prod.couleur_value[0]}"></span>
                                    <div>{{
                                            typeof
                                                prod.couleur_value === 'string' ? prod.couleur_name : prod.couleur_name[0]
                                        }}
                                    </div>
                                </div>
                                <span class="tips">{{ langPage['v4-panier']['TXT_sauvegarderpourplustard'] }}</span>
                            </div>
                        </div>
                        <el-divider></el-divider>
                        <el-row type="flex" align="middle" class="size">
                            <div class="sku">
                                <div v-for="(size,sizeIndex) in prod.sizeList"
                                     class="item"
                                     :key="sizeIndex">
                                    <p>{{ size.size }}</p>
                                    <span v-if="prod.vendu_par!='tailles'">{{ size.num * prod.copeText }}</span>
                                    <input
                                        type="text"
                                        v-model="size.num"
                                        v-else
                                        @blur="tailBlur(prod,sizeIndex,maq)"
                                        @input="tailInput(prod,size.num,sizeIndex)"
                                        oninput="value=value.replace(/[^\d|0]/g, '')"
                                    />
                                </div>
                            </div>
                            <div>
                                <el-row type="flex" align="middle" class="paquest"
                                        v-show="prod.vendu_par!='tailles'">
                                    <p>{{ langPage['bov-catalogue-fiche']['TXT_paquet'] }}</p>
                                    <span>{{ prod.copeText }}</span>
                                </el-row>
                            </div>
                        </el-row>
                        <el-divider></el-divider>
                        <div class="price">
                            <div class="item">
                                <p>{{ langPage['v4-panier']['TXT_totalqte'] }}</p>
                                <span v-if="prod.vendu_par!=='tailles'">{{ prod.packTotal * prod.copeText }}</span>
                                <span v-else>{{ prod.qteTotal }}</span>
                                <!-- <span>{{prod.lignes.quantite_pack}}</span> -->
                            </div>
                            <div class="item">
                                <p>{{ langPage['v4-panier']['TXT_puht'] }}</p>
                                <span :class="{'item-other':prod.prixReduit}">{{ prod.prix }} €</span>
                                <span v-if="prod.prixReduit">{{ prod.prixReduit }} €</span>
                            </div>
                            <div class="item">
                                <p>{{ langPage['compte-commandes-virement-details']['TXT_totalht'] }}</p>
                                <span v-if="prod.vendu_par!=='tailles'">
                                                            {{
                                        (prod.prixReduit ? prod.prixReduit * (prod.packTotal * prod.copeText) : prod.prix * (prod.packTotal * prod.copeText)).toFixed(2)
                                    }}€</span>
                                <span v-else>
                                                            {{
                                        (prod.prixReduit ? prod.prixReduit * (prod.qteTotal) : prod.prix * (prod.qteTotal)).toFixed(2)
                                    }}€</span>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div v-if="active===2">
            <div class="adresses">
                <div class="left mr">
                    <p>{{ langPage['compte-popup-adresse']['TXT_adresselivraison'] }}</p>
                    <addCarte :width="isMobile?'75':'3.68'" :msg="adrLIVRAISON" :carteTitle="carteTitle"></addCarte>
                </div>
                <div class="left">
                    <p>{{ langPage['compte-popup-adresse']['TXT_adressefacturation'] }}</p>
                    <addCarte :width="isMobile?'75':'3.68'" :msg="adrFACTURATION" :carteTitle="carteTitle"></addCarte>
                </div>
            </div>
        </div>
        <div v-if="active===3">
            <div class="paiement">
                <p>{{ langPage['bov-commande-detail']['TXT_modepaiement'] }}: {{ command_group.payment_name }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import addCarte from "../../components/addCarte";
import tableCard from "./Articles/tableCard";

let formatUtils = require('@/utils/format');
export default {
    name: "",
    components: {
        addCarte,
        tableCard
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            loading: false,
            active: 0,
            tabList: [
                this.$store.state.langPage['compte-commandes-liste']['TXT_articles'],
                this.$store.state.langPage['v4-topmenu']['TXT_rupture'],
                this.$store.state.langPage['compte-commandes-details']['TXT_adresse'],
                // this.$store.state.langPage['v4-topmenu']['TXT_moyendepaiement']
            ],
            tablelist: [
                {
                    title: this.$store.state.langPage['lookbooks-grossistes']['TXT_date'],
                    key: "date_creation"
                },
                {
                    title: this.$store.state.langPage['v4-topmenu']['TXT_totalpayeht'],
                    key: "totalHt"
                },
                {
                    title: this.$store.state.langPage['v4-topmenu']['TXT_totalpayetc'],
                    key: "prix"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-details']['TXT_moyendepaiement'],
                    key: "payment_name"
                },
                {
                    title: this.$store.state.langPage['compte-commandes-details']['TXT_transporteur'],
                    key: "transport_name"
                }
            ],
            carteTitle: [
                {
                    title: this.$store.state.langPage['landingpage']['TXT_formnom'],
                    key: "NomContact",
                },
                {
                    title: this.$store.state.langPage['panier-adresse']['TXT_societe'],
                    key: "Societe",
                },
                {
                    title: this.$store.state.langPage['compte-commandes-details']['TXT_adresse'],
                    key: "adresse",
                },
                {
                    title: this.$store.state.langPage['compte-informations-popup-adresse']['TXT_telephone'],
                    key: "telephone",
                },
                {
                    title: this.$store.state.langPage['compte-informations-popup-adresse']['TXT_mobile'],
                    key: "mobile",
                },
                {
                    title: this.$store.state.langPage['v4-topmenu']['TXT_payname'],
                    key: "pay_name",
                    onlyShow: true
                }
            ],
            msg: [
                {
                    a: "Speed Transport 2000",
                    b: "F492744",
                    x: "ssdsds",
                    Téléphone: "111",
                    Site: "Site internet",
                    Commenaire:
                        "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
                }
            ],
            paiementnTitle2: [
                {
                    key: "a"
                },
                {
                    key: "b"
                },
                {
                    key: "c"
                },
                {
                    key: "d"
                }
            ],
            paiementn: [],
            tabledata: [],
            dataAll: {},
            command_group: {},
            commandes: [],
            stockout_products: [],
            adrLIVRAISON: [],
            adrFACTURATION: [],
        };
    },
    beforeRouteEnter(to, from, next) {
        console.log(to.fullPath)
        if (!to.query.acheteurId || !to.query.commandeId) {
            next({path: '/Commandes', replace: true})
            return
        }
        next()
    },
    computed: {
        getLang() {
            return localStorage.getItem("lang") || 'fr'
        },
        langPage() {
            return this.$store.state['langPage']
        },
    },
    filters: {
        toUpperCase(val) {
            if (!val) return "";
            return val.toUpperCase();
        }
    },
    created() {
        this.init()
    },
    mounted() {
        setTimeout(() => {
            this.paiementn = [
                {
                    a: "Speed Transport 2000",
                    b: "1324567891022",
                    c: "Expire le",
                    d: "19/20"
                }
            ];
        }, 200);
    },
    methods: {
        init() {
            this.get_commandes_groupes()
        },
        back() {
            this.$router.replace('/Commandes');
        },
        chooseTab(i) {
            this.active = i;
        },
        get_commandes_groupes() {//获取买家订单组详情
            let para = {
                id_ahceteur: this.$route.query.acheteurId,
                id_commande: this.$route.query.commandeId
            }
            this.loading = true;
            this.$api.info.get_commandes_groupes({
                id_langue: this.getLang,
                id_commande_groupe: para.id_commande
            }).then((res) => {
                this.loading = false;
                if (res.code === 0) {
                    this.dataAll = res.data;
                    this.command_group = this.dataAll.command_group;
                    this.commandes = this.dataAll.commandes;
                    if (this.dataAll.stockout_products && this.dataAll.stockout_products.length > 0) {
                        this.stockout_products = this.dataAll.stockout_products;
                    }
                    this.stockout_products.forEach(prod => {
                        this.handleProduct(prod);
                    })

                    //收货地址修改
                    this.commandes[0].adrLIVRAISON.pay_name = this.commandes[0].adrLIVRAISON.pay.texte_fr;
                    this.commandes[0].adrFACTURATION.pay_name = this.commandes[0].adrFACTURATION.pay.texte_fr;
                    this.adrLIVRAISON.push(this.commandes[0].adrLIVRAISON);
                    this.adrFACTURATION.push(this.commandes[0].adrFACTURATION);
                    for (let command of this.commandes) {
                        command.id_commande_groupe_name = this.command_group.id_commande_groupe_name;
                        for (let prod of command.produits) {
                            this.handleProduct(prod);
                        }
                    }
                    console.log('dataAll', this.dataAll);
                } else {
                    console.log(res.message);
                }
            })
        },
        //处理产品数据，增加sizeList和packTotal产品数量
        handleProduct(prod) {
            let sizeList = this.skuFilter(prod);
            prod.copeText = prod.pack_qte;
            let packVal = 0;
            if (prod.packs.length > 0) {
                for (var i = 0; i < prod.packs.length; i++) {
                    packVal += prod.packs[i];
                }
            }
            prod.packTotal = packVal;
            prod.checked = false;
            prod.sizeList = sizeList;
            return prod;
        },
        //获取表格的数据
        getTableValue(item) {
            if (item.key === 'date_creation') {
                return formatUtils.parseTime(this.command_group[item.key], '{d}-{m}-{y}');
            }
            return this.command_group[item.key];
        },
        skuFilter(para) {
            let arr = [];
            if (para.vendu_par == "tailles") {
                for (let i = 0; i < para.size.length; i++) {
                    arr.push({
                        size: para.size[i],
                        num: para.ligne[i]
                    });
                }
                return arr;
            }
            for (let i = 0; i < para.size.length; i++) {
                arr.push({
                    size: para.size[i],
                    num: para.packs[i]
                });
            }
            return arr;
        }
    }
};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/Moncompte/Articles.less">
</style>
